<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import DwdcqkdjBrowse from "./DwdcqkdjBrowse";
import DwdcqkdjEdit from "./DwdcqkdjEdit";
import DwdcqkdjForm from "./DwdcqkdjForm";
export default {
    name: "Dwdcqkdj",
    components: { DwdcqkdjBrowse, DwdcqkdjEdit, DwdcqkdjForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "DwdcqkdjEdit";
            } else if (this.editProps.showForm === true) {
                return "DwdcqkdjForm";
            } else {
                return "DwdcqkdjBrowse";
            }
        }
    }
};
</script>
